import {FormValidator} from "../../helpers/validator";
import {Form} from "react-bootstrap";
import React, {useState} from "react";
import ConsoleLogger from "../../services/logging/logger";
import Loading from "../Transitions/Loading";

type FormWithValidationProps = {
    validator: FormValidator,
    controlId: string;
    children: any;
    onSubmit(e: React.FormEvent<HTMLFormElement>):void;
};
const logger = new ConsoleLogger("FormWithValidation");
const FormWithValidation = (props: FormWithValidationProps) => {
    const [isValidated, setIsValidated] = useState(false);
    const [submitting, setSubmitting] = useState(false);
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        setSubmitting(true);
        logger.debug("Internal submit");
        e.preventDefault();
        e.stopPropagation();
        let result = props.validator.validate(e.target as HTMLFormElement);
        setIsValidated(true);
        if(!result){
            setSubmitting(false);  
            setTimeout(() => {  
                            
                const invalidFields = document.querySelectorAll('.form-control:invalid,.form-check-input:invalid,.form-select:invalid,.btn-check:invalid, .yn-radio:invalid');
                if(invalidFields.length > 0){
                    let field = invalidFields[0] as HTMLElement;
                    // Check if this is a YesNoToggle radio (yn-radio)
                    if (field.classList.contains('yn-radio')) {
                        // Focus on the element that is described by aria-describedby
                        const errorId = field.getAttribute('aria-describedby');
                        if (errorId) { 
                            const errorElement = document.getElementById(errorId);
                            if (errorElement) {
                                errorElement.focus();
                                
                                return;
                            }
                        }
                    }
                    // Otherwise, focus the field as before
                    field.focus();
                }
                
            }, 100);
            return;
        }
        props.onSubmit(e);
        setSubmitting(false);
    }
    return (
        <Form id={props.controlId} data-testid={props.controlId+'-test-form'} noValidate validated={isValidated} onSubmit={handleSubmit}>
            {submitting ? <Loading message="Saving..." /> : null}
            {props.children}
        </Form>
    );
}
export default FormWithValidation;